<template>
    <div>
        <div class="row q-ma-xs"></div>
         <div class='row justify-start gt-md'>
            <q-select
                v-model="priceId"
                float-label="Выбор прайса"
                radio
                filter
                autofocus-filter
                color="positive"
                inverted
                separator
                filter-placeholder='Фильтр'
                :options="getPrices"
                @input="changePrice"
                class='q-ma-md'
            />
            <q-btn 
                color='positive'
                label="новый прайс"
                icon="control_point"
                @click="newPrice"
                class='q-ma-md'
            />

        </div>

        <div class='row justify-between lt-lg'>
            <q-select
                v-model="priceId"
                float-label="Выбор прайса"
                radio
                filter
                autofocus-filter
                color="positive"
                inverted
                separator
                filter-placeholder='Фильтр'
                :options="getPrices"
                @input="changePrice"
                class='q-ma-sm'
            />
            <q-btn 
                color='positive'
                label="новый прайс"
                icon="control_point"
                @click="newPrice"
                class='q-ma-sm'
            />

        </div>

        <q-tabs 
            class="direction-select"
            color='tertiary'
            two-lines
            v-model="tabsModel"
        >
            <q-tab v-for="direction in directions" 
                    :key=direction.id 
                    :name='direction.id+""'
                    slot="title"
                    :alert=isAlert(direction.id)
            >
                {{direction.name}}
            </q-tab>
            <q-tab name="postCost" slot='title' :alert=isPostAlert>постобработка</q-tab>
    
            <!-- Targets -->
                <q-tab-pane v-for="direction in directions"  
                    :key='direction.id'  
                    :name='direction.id+""'>
                        <component 
                            v-bind:is="direction.price_component" 
                            :directionId=direction.id />
                </q-tab-pane>

                <!-- Создаем вкладку с ценами на постобработку -->
                <q-tab-pane name='postCost'>
                    <keep-alive>
                        <price_post></price_post>
                    </keep-alive>
                </q-tab-pane>

        </q-tabs>

        <q-modal v-model="addNewPriceModal" minimized :content-css="{padding: '40px', width:'50%'}" ref="modalRef">
            <q-icon name="fas fa-ruble-sign" class="addDialogIco gt-xs" color='primary' size='150px'/>
            <div class="q-display-1 q-mb-md">Новый прайс</div>
             
             <q-input 
                v-model="newPriceName" 
                float-label="Имя прайса"  
                name="priceName" 
                color="positive" 
                style="margin-bottom:20px;"  
                v-validate="'required'"/>
             
             <span class="error">{{ errors.first('priceName') }}</span>

             <q-select
                v-model="samplePriceId"
                float-label="Создать на основе"
                radio
                filter
                autofocus-filter
                color="positive"
                
                separator
                filter-placeholder='Фильтр'
                :options="getPrices"
                class="select-price-dialog"
            />

            <div class='q-mt-lg row no-wrap items-end justify-end'>
                <q-btn color="red" label="Отмена" @click="cancelAddNewPrice" class="q-ma-xs" outline />
                <q-btn color="green" label="Создать" @click="addNewPrice" style='width:150px'  class="q-ma-xs error_border" icon="add_to_queue" :loading="addProgress">
                    <q-spinner-facebook slot="loading" size="20px" />
                </q-btn>
                

            </div>

        </q-modal>

        <q-btn
            round
            v-if="notSaved"
            @click="savePrice"
            color="primary"
            size="lg"
            class="fixed"
            icon="save"
            style="right: 50px; bottom: 50px"
        />


    </div>
</template>

<script>

/* eslint-disable */

import price_shirka from './priceComponents/price_shirka';
import price_irka from './priceComponents/price_irka';
import price_UF from './priceComponents/price_UF';
import price_lateks from './priceComponents/price_lateks';
import price_post from './priceComponents/post_price';


export default {

    name : 'editPrices',

    components : {
        price_shirka,
        price_irka,
        price_UF,
        price_lateks,
        price_post
    },

    data () {
        return { 
            priceId : 1,
            oldPriceId : 1, //используется для отмены смены прайса
            tabsModel : '',
            addNewPriceModal : false,
            samplePriceId : null,
            newPriceName : '',
            addProgress : false,
        }
    },

    created() {

        if (this.$store.getters.allPrices.length == 0) {
            this.$store.dispatch('retrievePrices')
            .then(()=>{
            })
            .catch(error => {
                if (error == 401) { // значит не авторизован
                    this.$router.push('logout');
                }
            });

        }
        
        this.$store.dispatch('getPriceById', this.priceId); // начальная загрузка прайса по умолчанию
        this.$store.dispatch('getDirections');
        this.$store.dispatch('getMaterials');
        this.$store.dispatch('getQuality');

        eventBus.$on('savePrice', this.savePrice); // подписываемся на событие  "SavePrice" чтобы сохранять прайсы


    },
    beforeDestroy() {

        eventBus.$off('savePrice');

    },

    computed : {

        notSaved() {
            return this.$store.getters.anyNotSaved;
        },

        isPostAlert() {
            return this.$store.getters.savedPostStatus;
        },

        getPrices() {
            var list = [];
            if (this.$store.getters.allPrices==undefined) return list;
            this.$store.getters.allPrices.map((value, key)=>{
                list.push({label:value.name, value:value.id});
            });
          return list;
        },

        directions() {

            if (this.$store.getters.getAllDirections == undefined) return [];

            var list = this.$store.getters.getAllDirections;           
            if (list.length>0) {
                this.tabsModel = list[0].id+'';
            }
            return this.$store.getters.getAllDirections;           

        },


    },
    methods : {
        
        showNotify(nMessage, nType, detail='') {

            this.$admns.showNotify(nMessage, nType, detail);

        },

        savePrice() {
            this.$q.dialog({
                title: 'Внимание!',
                message: 'Сохранить прайсы?',
                ok: 'Сохранить',
                cancel: 'Отмена'
            }).then( ()=> {

                this.$store.dispatch('savePrice')
                .then(()=>{
                   this.showNotify('Прайс успешно сохранен', 'success', ''); 
                })
                .catch(()=>{
                   this.showNotify('Ошибка при сохранении прайса', 'error', ''); 
                });

            });
        },


        changePrice(newValue) {
            var self = this;
            if (this.$store.getters.anyNotSaved) {
                this.$q.dialog({
                    title: 'Внимание!',
                    message: "Текущий прайс не сохранен. Сохранить?",
                    ok: 'Сохранить',
                    cancel: 'Не сохранять'
                }).then( ()=> {

                    this.$store.dispatch('savePrice')
                    .then(()=>{
                        // self.showNotify('Прайс успешно сохранен', 'success', ''); 
                        self.$store.dispatch('getPriceById', newValue); // загружаем новый прайс
                        self.oldPriceId = newValue;
                    })
                    .catch(()=>{
                        // self.showNotify('Ошибка при сохранении прайса', 'error', ''); 
                    });

                })
                .catch(()=>{
                    // this.priceId = this.oldPriceId;
                    this.$store.dispatch('getPriceById', this.priceId); // загружаем новый прайс
                    this.oldPriceId = newValue;
                });
            
            } else {
                this.$store.dispatch('getPriceById', this.priceId); // загружаем новый прайс
                this.oldPriceId = newValue;
            }
             
        },
        
        isAlert(direction) {
            return this.$store.getters.savedStatus(direction);
        },

        newPrice() {
            this.addNewPriceModal = true;
        },

        cancelAddNewPrice() {
            this.addNewPriceModal = false;
            this.newPriceName = '';
            this.samplePriceId = null;
        },

        addNewPrice() {
            this.$validator.validate().then(result => {
                 if (!result) {
                     console.log("Не прошел проверку");           
                 } else { // если прошел проверку

                        this.addProgress = true;
                        this.$store.dispatch('createNewPrice',{priceName: this.newPriceName, samplePriceId : this.samplePriceId})
                        .then(awr=>{
                            this.priceId = awr;
                            this.changePrice(awr);
                            this.addProgress = false;
                        })
                        .catch(error =>{
                            console.log(error)
                        });


                        this.addNewPriceModal = false;
                        this.newPriceName = '';
                        this.samplePriceId = null;

                 }
            });
        },


    },
}
</script>

<style lang="scss" scoped>
    
    .select-price {
    }
    .direction-select {
    }
    .new-price-btn {
        margin:20px;
        margin-top: 35px;
        float: right;
    }
    .addDialogIco {
        float:left;
        margin: 30px;
        margin-left:0px;
    }
    .error {
        color : red;
        font-weight: bold;
    }

</style>
